module.exports = __webpack_public_path__ + "img/partner_logo2.4f13dfdc.png";